@if (canUse() && showWidget()) {
  <div class="chat-widget">
    @if (!widget.isOpen()) {
      @if (showTip()) {
        <div class="chat-tip" role="status">
          <p>
            <strong>Ask with AI</strong>
            Query any case — status, documents, or next steps.
          </p>
          <button type="button" class="chat-tip-close" (click)="dismissTip()" aria-label="Dismiss tip">×</button>
          <span class="chat-tip-arrow" aria-hidden="true"></span>
        </div>
      }
      <button type="button" class="chat-fab" (click)="widget.toggle()" aria-label="Open case assistant">
        <img class="bot-mark" [class.busy]="widget.asking()" src="/svayam-bot.png" alt="" aria-hidden="true" />
      </button>
    }

    <section class="chat-panel" [class.open]="widget.isOpen()" aria-label="Case assistant">
      <header class="chat-panel-head">
        <div class="chat-panel-title">
          <span class="chat-panel-icon" aria-hidden="true">AI</span>
          <div>
            <strong>Case Assistant</strong>
            @if (widget.scopedCaseId()) {
              <span class="scope-chip">
                This case
                <button type="button" (click)="widget.clearScope()" aria-label="Search all cases instead">×</button>
              </span>
            } @else {
              <span class="scope-chip muted">All confirmed cases</span>
            }
          </div>
        </div>
        <div class="chat-panel-actions">
          <a class="chat-icon-btn" routerLink="/assistant" (click)="widget.close()" aria-label="Open full-screen assistant" title="Open full screen">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" /></svg>
          </a>
          <button type="button" class="chat-icon-btn" (click)="widget.clearChat()" aria-label="Clear chat" title="Clear chat">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0-1 14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L4 6" /></svg>
          </button>
          <button type="button" class="chat-icon-btn" (click)="widget.close()" aria-label="Close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
          </button>
        </div>
      </header>

      <div class="chat-body" #chatBody aria-live="polite">
        @for (message of widget.messages(); track message.id) {
          <div class="message-row" [class.user]="message.role === 'user'">
            <div class="avatar" aria-hidden="true">
              @if (message.role === 'assistant') {
                <img class="bot-mark sm" src="/svayam-bot.png" alt="" />
              } @else {
                You
              }
            </div>
            <div class="message" [class.error]="message.isError">
              @for (line of parseMessageLines(message.text, message.citations); track $index) {
                @if (line.text) {
                  <p>{{ line.text }}</p>
                }
                @if (line.citations.length) {
                  <div class="result-list">
                    @for (c of line.citations; track c.grievanceId) {
                      <article class="result-card">
                        <div>
                          <strong>{{ c.subject || 'Untitled case' }}</strong>
                        </div>
                        <a class="open-link" [routerLink]="['/complaints', c.grievanceId]" (click)="widget.close()">Open</a>
                      </article>
                    }
                  </div>
                }
              }
            </div>
          </div>
        }
        @if (widget.asking()) {
          <div class="message-row">
            <div class="avatar" aria-hidden="true">
              <img class="bot-mark sm busy" src="/svayam-bot.png" alt="" />
            </div>
            <div class="message"><p class="thinking">Thinking…</p></div>
          </div>
        }
        @if (widget.messages().length === 1 && !widget.asking()) {
          <div class="suggestion-row">
            @for (s of widget.suggestions(); track s) {
              <button type="button" class="suggestion-chip" (click)="widget.ask(s)">{{ s }}</button>
            }
          </div>
        }
      </div>

      <form class="composer" (ngSubmit)="widget.ask()">
        <textarea
          #composerInput
          name="question"
          rows="4"
          autocomplete="off"
          [ngModel]="widget.query()"
          (ngModelChange)="widget.query.set($event)"
          (keydown)="onComposerKeydown($event)"
          placeholder="Ask about confirmed cases…"
          aria-label="Ask about confirmed cases"
          [disabled]="widget.asking()"
        ></textarea>
        <button type="submit" [disabled]="!widget.query().trim() || widget.asking()" aria-label="Send question">Send</button>
      </form>
    </section>
  </div>
}
